import React, { useState, useEffect } from 'react'

import sanityClient, { urlFor } from '../client'

import { SectionTitle } from '../components'

import ImageGallery from 'react-image-gallery';

const Awards = () => {
  const [awards, setAwards] = useState(null)

  useEffect(() => {
    // return the image object instead of raw url so we can build sized urls client-side
    sanityClient
      .fetch(
        `*[_type == "awards"]|order(orderRank){
      name,
      "img": img
    }`
      )
      .then((data) => setAwards(data))
      .catch(console.error);
  }, []);

  if (!awards) {
    return (
      <h1>Loading...</h1>
    )
  }

  const images = awards.map((award) => {
    return {
      original: urlFor(award.img).width(1200).url(),
      thumbnail: urlFor(award.img).width(340).height(240).url(),
      description: award.name
    }
  })

  return (
    <section id='awards' className='container px-6'>
      <SectionTitle title='Awards' />

      <p className='text-white text-lg pb-20 max-w-[800px] mx-auto text-center'>We have been incredibly fortunate, and through our dedicated efforts, we have received several prestigious awards, including the HBA BarberShop of the Year 2024 in the UK and the British Master Barbers BarberShop of the Year 2023 in the UK.</p>

      <div className='h-max'>
        <ImageGallery
          items={images}
          showPlayButton={false}
          lazyLoad={true}
        />
      </div>
    </section>
  )
}

export default Awards